"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = ItemProductCategory;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ItemProductCategory(_ref) {
  var product_tags = _ref.product_tags,
      sub_departement = _ref.sub_departement,
      departement = _ref.departement,
      id = _ref.id;
  var temp = [];
  product_tags && temp.push(product_tags);
  sub_departement && temp.push(sub_departement);
  departement && temp.push(departement);
  return /*#__PURE__*/_react["default"].createElement("div", null, temp.join(", "), /*#__PURE__*/_react["default"].createElement("sup", null, "[", id, "]"));
}

ItemProductCategory.propTypes = {
  product_tags: _propTypes["default"].string,
  sub_departement: _propTypes["default"].string,
  departement: _propTypes["default"].string.isRequired,
  id: _propTypes["default"].number.isRequired
};